import PhoneNumberStep from '../../steps/PhoneNumberStep';
import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const PHONE_NUMBER_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.PHONE_NUMBER,
  options: { countsTowardProgressBar: false, hideProgressBar: true, hideErrorToast: true },
  elements: [
    {
      uid: OnboardingStepType.PHONE_NUMBER,
      component: (
        <PhoneNumberStep
          uid={OnboardingStepType.PHONE_NUMBER}
          nodeType={OnboardingNodeType.PHONE_NUMBER}
          displayName=""
          actionButtonText="Continue"
          showAllContent={true}
          subheaderTextKey="yourNumberLetsUs"
          bulletPointTextKey={null}
        />
      )
    }
  ]
};
